"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubFlowBar = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./FlowBar.scss");
var getStepBadgeContent = function (flowStep) {
    if (flowStep.isReady) {
        return react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "CheckMark" });
    }
    return react_1.default.createElement(react_1.default.Fragment, null, flowStep.number);
};
exports.WsAiHubFlowBar = function (props) {
    var _a = props.ariaLabel, ariaLabel = _a === void 0 ? 'Flow progress' : _a, _b = props.className, className = _b === void 0 ? '' : _b, step = props.step, steps = props.steps;
    var _c = react_1.useState(null), menuTarget = _c[0], setMenuTarget = _c[1];
    var _d = react_1.useState([]), menuItems = _d[0], setMenuItems = _d[1];
    var normalizedSteps = react_1.useMemo(function () {
        if (steps && steps.length > 0) {
            return steps;
        }
        if (typeof step === 'number') {
            return [
                {
                    key: "step-" + step,
                    label: "Step " + step,
                    number: step,
                },
            ];
        }
        return [];
    }, [step, steps]);
    if (normalizedSteps.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var handleStepClick = function (flowStep, event) {
        var _a;
        (_a = flowStep.onClick) === null || _a === void 0 ? void 0 : _a.call(flowStep);
        if (!flowStep.menuItems || flowStep.menuItems.length === 0) {
            setMenuTarget(null);
            setMenuItems([]);
            return;
        }
        setMenuItems(flowStep.menuItems.map(function (menuItem) { return ({
            key: menuItem.key,
            text: menuItem.label,
            disabled: menuItem.disabled,
            onRenderContent: function () { return (react_1.default.createElement("div", { className: "ws-ai-hub-flow-bar-menu-item-content" },
                react_1.default.createElement("span", { className: "ws-ai-hub-flow-bar-menu-item-label" }, menuItem.label),
                menuItem.isReady ? (react_1.default.createElement("span", { className: "ws-ai-hub-flow-bar-menu-item-ready-badge", "aria-hidden": "true" },
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "CheckMark" }))) : null)); },
            onClick: function () {
                menuItem.onClick();
                setMenuTarget(null);
                setMenuItems([]);
            },
        }); }));
        setMenuTarget(event.currentTarget);
    };
    return (react_1.default.createElement("div", { className: ("ws-ai-hub-flow-bar " + className).trim(), "aria-label": ariaLabel, role: "group" },
        normalizedSteps.map(function (flowStep, index) {
            var isLastStep = index === normalizedSteps.length - 1;
            var hasContextMenu = !!flowStep.menuItems && flowStep.menuItems.length > 0;
            return (react_1.default.createElement(react_1.default.Fragment, { key: flowStep.key },
                react_1.default.createElement("button", { type: "button", className: ("ws-ai-hub-flow-bar-step " + (flowStep.isReady ? 'ws-ai-hub-flow-bar-step--ready' : '') + " " + (hasContextMenu ? 'ws-ai-hub-flow-bar-step--menu-enabled' : '')).trim(), disabled: flowStep.disabled, onClick: function (event) {
                        handleStepClick(flowStep, event);
                    } },
                    react_1.default.createElement("span", { className: ("ws-ai-hub-flow-bar-step-badge " + (flowStep.isReady ? 'ws-ai-hub-flow-bar-step-badge--ready' : '')).trim() }, getStepBadgeContent(flowStep)),
                    react_1.default.createElement("span", { className: "ws-ai-hub-flow-bar-step-label" }, flowStep.label)),
                !isLastStep ? (react_1.default.createElement("span", { className: ("ws-ai-hub-flow-bar-divider " + (flowStep.isReady ? 'ws-ai-hub-flow-bar-divider--ready' : '')).trim(), "aria-hidden": "true" })) : null));
        }),
        react_1.default.createElement(office_ui_fabric_react_1.ContextualMenu, { hidden: !menuTarget, target: menuTarget, items: menuItems, onDismiss: function () {
                setMenuTarget(null);
                setMenuItems([]);
            } })));
};
